const GOOGLE_MAP_KEY = process.env.REACT_APP_GOOGLE_MAP_KEY;

export { GOOGLE_MAP_KEY };